module.exports = __webpack_public_path__ + "static/media/fan4_lamp1.49729695.gif";